module.exports = __webpack_public_path__ + "img/book-open-cover.edda5742.svg";